// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__pz7qM","spinnerFadeIn":"Spinner_spinnerFadeIn__mebrh","spinnerRotate":"Spinner_spinnerRotate__S00lN","loaderInverted":"Spinner_loaderInverted__DV3Cg"};